import { useState } from 'react';
import { FaCaretUp, FaCaretDown } from 'react-icons/fa'
import "./style.css";

const CustomFilterIcons = ({ Sort, active }) => {

    const [order, setOrder] = useState("DESC");

    return (
        <div className="custom-sort">
            <FaCaretDown
                className={`${active && "active-sort"} ${order === "ASC" && "active-sort-rotate"}`}
                size={20}
                onClick={() => {
                    if (order === "DESC") {
                        Sort(active ? "ASC" : "DESC");
                        setOrder(active ? "ASC" : "DESC");
                    } else if (order === "ASC") {
                        Sort(active ? "DESC" : "ASC");
                        setOrder(active ? "DESC" : "ASC");
                    }

                }} />

            {/* {
                order === "ASC" &&
                <FaCaretUp
                    className={`${active && "active-sort"}`}
                    size={20}
                    style={{  }}
                    onClick={() => {
                        Sort(active ? "DESC" : "ASC");
                        setOrder(active ? "DESC" : "ASC");
                    }} />
            } */}
        </div>
    );
};

export default CustomFilterIcons;